"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var orderingRow_1 = require("./orderingRow");
var mobx_react_1 = require("mobx-react");
var react_sortable_hoc_1 = require("react-sortable-hoc");
var utils_1 = require("../../utils");
var SortableItem = (0, react_sortable_hoc_1.SortableElement)(function (props) { return (React.createElement(orderingRow_1.default, { ordering: props.item, change: props.change })); });
var SortableList = (0, react_sortable_hoc_1.SortableContainer)(function (props) {
    return (React.createElement("div", null, props.items.map(function (item, index) { return (React.createElement(SortableItem, { key: index, index: index, item: item, change: props.change.bind(_this, index) })); })));
});
var OrderingList = (function (_super) {
    __extends(OrderingList, _super);
    function OrderingList(props) {
        var _this = _super.call(this, props) || this;
        _this.onSortEnd = function (_a) {
            var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
            var changeList = (0, utils_1.arrayMoveClone)(_this.state.ordering, oldIndex, newIndex);
            _this.updateOrdering(changeList);
            var currentItem = changeList[newIndex];
            if (currentItem.active) {
                _this.updateUrl(changeList);
            }
        };
        _this.updateOrdering = function (ordering) {
            _this.setState({
                ordering: ordering
            });
        };
        _this.updateUrl = function (ordering) {
            var orders = [];
            var order_types = [];
            ordering.forEach(function (item) {
                if (item.active) {
                    orders.push(item.index.toString());
                    order_types.push(item.ascending ? 'asc' : 'desc');
                }
            });
            var location = window.location.search;
            var params = new URLSearchParams(location);
            params.set('o', orders.join(','));
            params.set('ot', order_types.join(','));
            params.delete('page');
            window.history.pushState(null, null, window.location.pathname + "?" + params.toString());
            _this.props.onOrder();
        };
        _this.onChange = function (index, event) {
            var newOrderings = _this.state.ordering.slice();
            var newOrdering = __assign({}, newOrderings[index]);
            var target = event.currentTarget;
            if (target.name == 'name') {
                newOrdering.active = target.checked;
            }
            else {
                newOrdering.ascending = target.checked;
            }
            newOrderings[index] = newOrdering;
            _this.updateOrdering(newOrderings);
            if (target.name == 'name') {
                _this.updateUrl(newOrderings);
            }
            else if (newOrdering.active) {
                _this.updateUrl(newOrderings);
            }
        };
        _this.state = {
            ordering: _this.props.ordering
        };
        return _this;
    }
    OrderingList.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (JSON.stringify(nextProps.ordering) !== JSON.stringify(this.state.ordering)) {
            this.updateOrdering(nextProps.ordering);
        }
    };
    OrderingList.prototype.render = function () {
        return (React.createElement("div", { className: "m-2" },
            React.createElement("div", { className: "header" },
                React.createElement("h3", null, gettext("Ordering"))),
            React.createElement("ul", { className: "list-group" },
                React.createElement(SortableList, { lockAxis: "y", items: this.state.ordering, change: this.onChange, onSortEnd: this.onSortEnd, useDragHandle: true }))));
    };
    OrderingList = __decorate([
        mobx_react_1.observer
    ], OrderingList);
    return OrderingList;
}(React.Component));
exports.default = OrderingList;
